import { render, staticRenderFns } from "./CbsObjects.vue?vue&type=template&id=2d81c94f&scoped=true"
import script from "./CbsObjects.vue?vue&type=script&lang=js"
export * from "./CbsObjects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d81c94f",
  null
  
)

export default component.exports